module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-8d41029ef386930c4f7fc667373c7f8a.png";